var App = App || {};

App.WidgetVideoLibrary = (function ($) {
    'use strict';

    function Scroll(selector) {
        const category = App.Base.GetUrlParameter("Category");
        if (category !== "") {
            $("html, body").animate({ scrollTop: selector.offset().top }, 200);
        }
    }

    return {
        Scroll: Scroll
    };

})(jQuery);